import { generateClient } from 'aws-amplify/api';
import { updateDailyReport } from "../graphql/mutations";

const client = generateClient();

export default async({id, jobNumber, submissionDate, summary, isCompleted, questions, userId}) => {
    try{
        const {
            data: {updateDailyReport: updatedDailyReport}
        } = await client.graphql({
            query: updateDailyReport,
            variables: {
                input:{
                    id, 
                    jobNumber, 
                    submissionDate, 
                    summary, 
                    isCompleted, 
                    questions, 
                    userId
                },
            },
        });
        return updatedDailyReport;
    } catch(ex) {
        console.error("Failed to update daily report", ex);
    }
};